/**
 * SettingsIconButton Component
 *
 * Reusable gear icon button for opening settings
 * Used across IntroScreen, SetupWizard, and NarrativeUI
 */

import React from 'react';
import { useTheme } from '../../../services/ThemeContext';

interface SettingsIconButtonProps {
  onClick: () => void;
  style?: React.CSSProperties;
  'data-testid'?: string; // Allow parent to specify testid
}

const SettingsIconButton: React.FC<SettingsIconButtonProps> = ({ onClick, style, 'data-testid': testId = 'settings-button' }) => {
  const { currentTheme: colors } = useTheme();

  return (
    <button
      onClick={onClick}
      data-testid={testId}
      style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, ...style }}
      aria-label="Open Settings"
    >
      <span style={{ fontSize: 28, color: colors.primary }}>⚙</span>
    </button>
  );
};

export default SettingsIconButton;
